export const paymentTermsFilterFields = ['name'];

export const paymentTermsSelectLabel = object => {
  return `${object.name}`;
};
